import styled, { css } from 'styled-components';
import { Button } from '@awaze/design-system.components.button';
export const LabelContainer = styled.div `
  width: 100%;
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
`;
export const StepperInnerContainer = styled.div `
  width: fit-content;
  margin-left: auto;
  margin-top: 16px;
`;
export const ImageStyled = styled.img `
  border-radius: 4px;
  margin-bottom: 16px;
`;
export const IconStyled = styled.div `
  margin-bottom: 16px;
`;
export const DescriptionStyled = styled.div `
  margin-top: 10px;
  color: ${({ theme }) => `${theme.ColorGrey700}`};
`;
export const ButtonStyled = styled(Button) `
   {
    margin-top: 16px;
     ${({ color, theme }) => {
    const buttonColor = theme[color];
    return css `
          color: ${buttonColor};
          border-color: ${buttonColor};
          &:hover,
          &:focus {
            box-shadow: none;
            color: ${buttonColor};
            border-color: ${buttonColor};
    `;
}}
`;
export const StepperContainer = styled.div `
  margin-bottom: 16px;

  && {
    border-radius: 8px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    width: 100%;

    &.price {
      margin-left: auto;
    }
  }
`;
//# sourceMappingURL=item-stepper.styles.js.map